module.exports = __webpack_public_path__ + "static/img/4_2_3.41326d5d.jpg";